import { Box, Paper, Stack, Typography } from "@mui/material";
import Warning from "@mui/icons-material/Warning";
import type { SmartAction } from "../../../types/types";
import { Check } from "@mui/icons-material";

interface SmartActionItemProps {
  action: SmartAction;
}

export default function SmartActionItem({ action }: SmartActionItemProps) {
  return (
    <Paper
      sx={{
        bgcolor: action.status === "complete" ? "#F0FDFA" : "#FEF3C7",
        borderRadius: "8px",
        p: 1,
        boxShadow: 0,
        height: "100%",
      }}
    >
      <Stack direction="row" spacing={1} alignItems="center">
        <Box
          sx={{
            width: 20,
            height: 20,
            borderRadius: "10px",
            bgcolor: action.color,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          {action.status === "complete" ? (
            <Check sx={{ fontSize: 10, color: "white" }} />
          ) : (
            <Warning sx={{ fontSize: 12, color: "white" }} />
          )}
        </Box>
        <Box sx={{ flex: 1 }}>
          <Typography
            sx={{
              fontWeight: 600,
              fontSize: "12px",
              color: action.color,
            }}
          >
            {action.title}
          </Typography>
          <Typography
            sx={{
              fontWeight: 400,
              fontSize: "10px",
              color: action.color,
            }}
          >
            {action.subtitle}
          </Typography>
        </Box>
        <Typography
          sx={{
            fontWeight: 400,
            fontSize: "12px",
            color: action.color,
          }}
        >
          {action.progress}
        </Typography>
      </Stack>
    </Paper>
  );
}
